import { TYPE_BOOLEAN } from './input-types';

export const id = 'allocationStatus';
export const apiKey = 'IsAllocated';
export const type = TYPE_BOOLEAN;

export const allocationStatus = {
  id,
  apiKey,
  type,
};
